export class County {
    id!: string
    name!: string
    stateAbbr!: string
    combinedName!: string

    protected $setProperties(source: any): void {
        source.combinedName = source.name + ', ' + source.stateAbbr
    }
}
